// @ts-nocheck

export default {
  colors: {
    black: '#121213',
    darkgrey1: '#1b1c1e',
    darkgrey2: '#1f2022',
    darkgrey3: '#28292d',
    darkgrey4: '#36383e',
    darkgrey5: '#424547',
    middlegrey1: '#606467',
    middlegrey2: '#888b8d',
    middlegrey3: '#a9aeb1',
    lightgrey: '#c1c9cf',
    grey: '#232323',
    redlight: '#ff0003',
    greenwin: '#10ed40',
    red200: '#e50914',
    red650: '#b20e10',
    yellow: '#ffc514',
  },
  gradients: {
    red: (deg = 250) => `linear-gradient(${deg}deg, #e63f41, #b20f10)`,
    black: (deg = 250) => `linear-gradient(${deg}deg, #1f2022, #121213)`,
  },
  desktopBloc: `
    border-radius: 0.4em;
    box-shadow: 0 0 15px 0 rgba(27, 28, 30, 0.65);
    background: #121213;
  `,
};
